import { inject, Injectable, signal } from '@angular/core';
import { interval, Observable, Subject, Subscription } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

import { ICounter } from '../shared/interfaces/common.interface';
import { WINDOW } from './window';

interface Event {
  key: string;
  value: any;
}

@Injectable({
  providedIn: 'root',
})
export class EventService {
  protected eventsSubject = new Subject<Event>();
  public count: number = 0;

  private readonly _daysCounter = signal<ICounter>({ _days: 0, _hours: 0, _minutes: 0, _seconds: 0, _diff: 0 });
  readonly daysCounter = this._daysCounter.asReadonly();

  private stopper = new Subject();
  private counter!: Subscription;

  private readonly window = inject(WINDOW);

  public broadcastEvent(key: string, value: any): void {
    this.eventsSubject.next({ key, value });
  }

  public getEvent(key: string): Observable<Event> {
    return this.eventsSubject.asObservable().pipe(
      filter((e) => e.key === key),
      map((e) => e.value),
    );
  }

  resetCounter() {
    if (this.counter) this.counter?.unsubscribe();
    this.stopper = new Subject();
  }

  setCounter(endDate: number) {
    let _diff: number;
    this.counter = interval(1000)
      .pipe(
        takeUntil(this.stopper),
        map(() => {
          _diff = endDate - Date.parse(new Date().toString());
        }),
      )
      .subscribe(() => {
        if (_diff <= 0) {
          this.broadcastEvent('ROUND-END', true);
          this.stopper.next(false);
        } else {
          const object: ICounter = {
            _days: this.getDays(_diff) < 10 ? '0' + this.getDays(_diff) : this.getDays(_diff),
            _hours: this.getHours(_diff) < 10 ? '0' + this.getHours(_diff) : this.getHours(_diff),
            _minutes: this.getMinutes(_diff) < 10 ? '0' + this.getMinutes(_diff) : this.getMinutes(_diff),
            _seconds: this.getSeconds(_diff) < 10 ? '0' + this.getSeconds(_diff) : this.getSeconds(_diff),
            _diff,
          };
          this._daysCounter.set(object);
        }
      });
  }

  getDays(t: number) {
    return Math.floor(t / (1000 * 60 * 60 * 24));
  }

  getHours(t: number) {
    return Math.floor((t / (1000 * 60 * 60)) % 24);
  }

  getMinutes(t: number) {
    return Math.floor((t / 1000 / 60) % 60);
  }

  getSeconds(t: number) {
    return Math.floor((t / 1000) % 60);
  }

  scrollToFn(section: string) {
    if (this.window) {
      window.location.hash = section;
    }
  }

  showBuyWidget(scrollTo: string = ''): void {
    this.scrollToFn(scrollTo);
  }
}
